import React, { Fragment, useEffect } from 'react';
import styled from 'styled-components';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { breadcrumbSelector } from 'src/redux/app/selectors';
import { activeFilterSelector, getFiltersOpen } from 'src/redux/bikes/selectors';
import theme, { maxBp } from 'src/lib/theme';
import { setActiveFilter } from 'src/redux/bikes/actions';
import { getViewportWidth } from 'helpers/utilities';
import Link from '../Link/Link';

const A = styled.a``;

const OL = styled.ol`
  @media ${maxBp('tabletLarge')} {
    li {
      display: none !important;
    }

    li:nth-child(-n + 2) {
      display: inline-block !important;
    }

    li:nth-child(2) {
      i {
        display: none;
      }
    }
  }
`;

const Breadcrumb = ({ additionalLinks = [] }) => {
  const breadcrumb = useSelector(breadcrumbSelector);
  const hybridBreadcrumb = (breadcrumb || []).concat(additionalLinks);
  let breadcrumbEl = document.querySelector('.breadcrumb');
  const activeFilter = useSelector(activeFilterSelector);
  const dispatch = useDispatch();
  const filtersOpen = useSelector(getFiltersOpen);

  if (!breadcrumbEl) {
    breadcrumbEl = document.createElement('div');
    breadcrumbEl.classList.add('breadcrumb');
    document.body.appendChild(breadcrumbEl);
  }

  breadcrumbEl.style.display = 'block';
  breadcrumbEl.classList.add('configurator');

  if (filtersOpen && getViewportWidth() <= theme.breakpoints.tablet) {
    breadcrumbEl.style.display = 'none';
  }

  const handleBreadcrumbClick = () => {
    if (typeof activeFilter === 'number') {
      dispatch(setActiveFilter(null));
    }
  };

  return (
    <>
      {createPortal(
        <OL vocab="http://schema.org/" typeof="BreadcrumbList" onClick={handleBreadcrumbClick}>
          {hybridBreadcrumb.map((link, index) => {
            const isCurrentPage = index + 1 === hybridBreadcrumb.length;
            const linkProps = {};
            let LinkEl = Fragment;

            if (!isCurrentPage) {
              if (link.siteLink) {
                linkProps.property = 'item';
                linkProps.typeof = 'WebPage';
                linkProps.href = link.url;
                LinkEl = A;
              } else {
                linkProps.to = link.url;
                LinkEl = Link;
              }
            }

            return (
              <li key={`${link.url}_${link.text}`} property="itemListElement" typeof="ListItem">
                <LinkEl {...linkProps}>
                  {typeof link.text === 'string' ? (
                    <span property="name" dangerouslySetInnerHTML={{ __html: link.text }}></span>
                  ) : (
                    <span property="name">{link.text}</span>
                  )}
                  {link.home ? <i aria-hidden="true" className="icon icon--home"></i> : null}
                  {index + 1 !== hybridBreadcrumb.length ? (
                    <i aria-hidden="true" className="icon icon--chevron-right"></i>
                  ) : null}
                </LinkEl>
                <meta property="position" content={index + 1} />
              </li>
            );
          })}
        </OL>,
        breadcrumbEl
      )}
    </>
  );
};

export default Breadcrumb;
